import { doPayment, getOrder } from '../../api/Orders';
import { Order } from '../../models/Order';
import Loading from 'vue-loading-overlay';

import 'vue-loading-overlay/dist/vue-loading.css';

export default {
    name: 'Payment',
    components: { Loading },
    data: function () {
        return {
            order: new Order(),
            forms: {
                payment: {
                    bankslip: {
                        name: "",
                        nif: "",
                        address:{
                            zipcode: "",
                            number: "",
                            street: "",
                            complement: "",
                            district: "",
                            city: "",
                            uf: ""
                        }
                    },
                    creditcard: {
                        number: "",
                        name: "",
                        due: "",
                        cvc: "",
                        recurrence: false,
                        payment_source: ""
                    },
                    method: 'bankslip'
                }
            },
            ui:{
                scope: 'payment',
                loading: true,
                pageLoading: true,
                result: {
                    success: false,
                    message: ""
                }
            }
        }
    },
    created () {
        this.fetchData()
    },
    methods:{
        fetchData () {
            let vm = this

            getOrder().then(response => {
                vm.order = new Order(response);
                vm.ui.pageLoading = false

                vm.forms.payment.bankslip.name                  = response.company.business_name ? response.company.business_name : response.company.name
                vm.forms.payment.bankslip.nif                   = response.company.nif
                vm.forms.payment.bankslip.address.zipcode       = response.company.zipcode
                vm.forms.payment.bankslip.address.number        = response.company.number
                vm.forms.payment.bankslip.address.street        = response.company.street
                vm.forms.payment.bankslip.address.complement    = response.company.complement
                vm.forms.payment.bankslip.address.district      = response.company.district
                vm.forms.payment.bankslip.address.city          = response.company.city
                vm.forms.payment.bankslip.address.uf            = response.company.uf

                if(vm.order.currency !== 'brl'){
                    vm.forms.payment.method = 'creditcard'
                    vm.ui.scope = 'payment'
                }
            })
        },
        goToScopePayment(){
            this.ui.scope = 'payment';

            this.ui.loading        = true
            this.ui.result.success = true
            this.ui.result.message = 'sending_lead'
        },
        doBankslipPayment(){
            let vm = this
            vm.$ga.event('Order', 'doBankslipPayment', 'Bankslip payment attempt')

            this.$validator.validate('bankslip.*', null, { silent: true }).then( isValid => {
                if(isValid){
                    vm.ui.scope = 'result'

                    let dataObj = {
                        method: 'bankslip',
                        order_id: vm.order.id,
                        name: vm.forms.payment.bankslip.name,
                        nif: vm.forms.payment.bankslip.nif,
                        address: vm.forms.payment.bankslip.address
                    }

                    doPayment(dataObj).then(function (result) {
                        vm.order = new Order(result)
                        vm.ui.loading = false

                        vm.ui.result.success = true
                        vm.ui.result.message = 'bankslip_success_lead'
                    }, function (error) {
                        vm.ui.loading = false
                        vm.ui.result.success = false

                        if(error.response.data.message.length > 0){
                            vm.ui.result.message = error.response.data.message
                        } else {
                            vm.ui.result.message = 'bankslip_error_lead'
                        }
                    })
                }
            })
        },
        doCreditcardPayment(){
            let vm = this

            vm.$ga.event('Order', 'doCreditcardPayment', 'Creditcard payment attempt')

            this.$validator.validate('creditcard.*', null, { silent: true }).then( isValid => {
                if(isValid){
                    vm.ui.scope = 'result'

                    Stripe.setPublishableKey(process.env.VUE_APP_STRIPE_PUBLIC_KEY)

                    Stripe.card.createToken({
                        name: vm.forms.payment.creditcard.name,
                        number: vm.forms.payment.creditcard.number,
                        cvc: vm.forms.payment.creditcard.cvc,
                        exp_month: vm.forms.payment.creditcard.due.split("/")[0],
                        exp_year: vm.forms.payment.creditcard.due.split("/")[1]
                    }, function (status, result) {
                        if (status !== 200) { // Problem!
                            vm.ui.result.success = false
                            vm.ui.result.message = 'creditcard_error_lead'
                        } else {
                            let dataObj = {
                                method: 'creditcard',
                                order_id: vm.order.id,
                                payment_source : result.id,
                                recurrence: vm.forms.payment.creditcard.recurrence
                            }

                            doPayment(dataObj).then(function (result) {
                                vm.order = new Order(result)
                                vm.ui.loading = false

                                vm.ui.result.success = true
                                vm.ui.result.message = 'creditcard_success_lead'
                            }, function (error) {
                                vm.ui.loading = false
                                vm.ui.result.success = false

                                if(typeof error.response.data.message !== "undefined" && error.response.data.message.length > 0){
                                    vm.ui.result.message = error.response.data.message
                                } else {
                                    vm.ui.result.message =  vm.forms.payment.method === 'creditcard' ? 'creditcard_error_card_declined' : 'creditcard_error_lead'
                                }
                            })
                        }
                    });
                }
            })
        }
    }
}